module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Rampchart.js"));
	}, "Rampchart");
}